import React, { useEffect } from 'react';
import {connect} from "react-redux";
import {Card, CardBody, CardTitle } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';

// components
import RestrictionForm from "./_form";
import RestrictionFilters from "./_filters";
import {ActiveFormatter} from "../../../components/tables/activeFormater";
import TranslateButton from "../../../components/buttons/TranslateButton";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import { GenericTableButton,} from "../../../components/buttons/buttonsActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";

// labels
import { LIST, NO_DATA_FOUND } from "../../../components/i18n/i18n";
import {TT_DELETE, TT_EDIT,} from "../../../components/i18n/toolTips";

// service
import {restrictionService} from "../../../jwt/_services/clasificator/restrictionService";

// actions
import { genericActions } from "../../../redux/actions/generics/GenericActions";
import { setForm, setItem } from "../../../redux/actions/generalActions/formActions";
import { setViewMode, setParent  } from "../../../redux/actions/generalActions/mainActions";
import { setFilter, setTableParams } from "../../../redux/actions/generalActions/listActions";
import {ColorFormatter} from "../../../components/tables/colorFormatter";
import LangRestrictionRow from "./_langRow";


const RestrictionList = props => {
    const { app } = props.mainProps
    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listProps

    // asignar los valores por default del filtro
    useEffect( () => {
        if( !app.id || filter)
            return

        const _filter = {
            onlyRegistered : true,
            fbDataBase : { id : app?.fbDataBase?.id },
            item : {
            }
        };

        props.setFilter(_filter);
    }, [ app ]);

    // realizar búsqueda cuando cambie el filtro
    useEffect(() => {
        if(!filter)
            return

        genericActions.search(restrictionService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter ]);

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams( tableChangeParams.sizePerPage, currentIndex );
    };

    const confirmDelete = (data) => {
        return ConfirmDelete({ remove : genericActions.remove , data : data, fbDataBaseId :  app?.fbDataBase?.id, service: restrictionService } );
    };

    const editItem = (data) => {
        props.setForm(true, false, false);
        props.setItem(data);
        ModalFormContainer(RestrictionForm, { data, Form: RestrictionForm })
    }

    const activeFormatter = (cell) => {
        return (
            <ActiveFormatter active={cell}/>
        );
    }

    const actionsFormatter = (cell, row) => {
        return (
            <div className="float-left">
                <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
                <TranslateButton item={row} service={restrictionService} />
                <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
            </div>
        );
    }

    const colorFormatter = (cell) => <ColorFormatter color={cell}/>

    const expandRow = {
        renderer: row => <LangRestrictionRow row={row}/>,
        showExpandColumn : true
    };

    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'uid',
        text: 'uid',
        sort: true
    }, {
        dataField: 'name',
        text: 'Nombre'
    }, {
        dataField: 'code',
        text: 'Código'
    }, {
        dataField: 'icon',
        text: 'Icono',
        headerAlign: 'center',
        align: 'center',
    }, {
        dataField: 'colorHex',
        text: "Color Hex",
        headerAlign: 'center',
        align: 'center',
        formatter: colorFormatter
    }, {
        dataField: 'colorRgb',
        text: "Color RGB",
        headerAlign: 'center',
        align: 'center',
        formatter: colorFormatter
    }, {
        dataField: 'status',
        text: "Activo",
        headerAlign: 'center',
        align: 'center',
        formatter: activeFormatter
    }, {
        dataField: 'actions',
        isDummyField: true,
        text: 'Acción',
        headerAlign: 'center',
        align: 'center',
        headerStyle: {width: '200px'},
        formatter: actionsFormatter
    }];

    return (
        <div>
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-list-alt mr-2"> </i>{LIST}
                </CardTitle>

                <RestrictionFilters />

                <CardBody className="">
                    <BootstrapTable
                        striped hover
                        tableHeaderClass='mb-0'
                        remote
                        keyField="id"
                        data={listDomainObjects || []}
                        columns={columns}
                        expandRow={expandRow}
                        noDataIndication={NO_DATA_FOUND}
                        pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                        onTableChange={handleTableChange}
                    />
                </CardBody>
            </Card>
        </div>
    )
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    listProps : state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    setParent,
})
export default connect(mapStateToProps, mapActionsToProps)(RestrictionList)